import { cloneElement, useState } from 'react';
import { isEmpty } from 'underscore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AddButton } from './AddButton';

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import { jsx as _jsx } from "react/jsx-runtime";
const hasValue = formData => {
  if (typeof formData === 'object') {
    return !isEmpty(formData);
  }
  return typeof formData !== 'undefined';
};
const CollapseFieldWrapper = ({
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  children,
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  collapsed,
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  formData,
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  isAdditionalProperty
}) => {
  const [state, setState] = useState({
    showInput: hasValue(formData),
    autoFocus: false
  });
  if (!collapsed) {
    return children;
  }
  if (state.showInput || isAdditionalProperty) {
    return /*#__PURE__*/cloneElement(children, {
      autoFocus: state.autoFocus
    });
  }
  return /*#__PURE__*/_jsx(AddButton, {
    onClick: () => {
      setState({
        showInput: !state.showInput,
        autoFocus: true
      });
    },
    "data-test-id": "set-test-value",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "developer-docs-shared-components.params.body.setTestValue"
    })
  });
};
export default CollapseFieldWrapper;